<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Table
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<ng-container *ngIf="isBrowser;else noJsContent">
<div class="content content--modifier-height">

    <h2>Customized useCase options for Table</h2>
    <div class="content__tools-wrap">
      <div class="content__row">
        <label for="useCase" class="content__row-label">Use Cases</label>
        <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
          <ng-container *ngFor="let useCase of useCases">
            <option [value]="useCase">{{ useCase }}</option>
          </ng-container>
        </select>
      </div>        
    </div>

</div>

<div class="content" *ngIf="selectedUseCase === 'tableWithPaginationHeaderAndNumerics'">
  <h2>Table with Pagination, Header and Numerics</h2>
  <div class="c-table-result">
    {{label}}
    <span class="c-table-result__buttons" *ngIf="screenSize>minimumScreenResolution">
      <maced-button buttonId="buttonId" size="small" icon="icon-book-closed" type="button" label="Digital Test"
        [disabled]="hasDigitalTest" [url]="currentUrl" position="right">
      </maced-button>
      <maced-button buttonId="buttonId1" size="small" icon="icon-book-open" type="button" label="Paper Test"
        [disabled]="hasPaperTest" [url]="currentUrl" position="right">
      </maced-button>
    </span>
    <span *ngIf="screenSize<=minimumScreenResolution" class="c-table-result__buttons c-table-result__buttons--dropdown">
      <maced-dropdown dropdownId="dropdownId1" name="dropdownId1" ariaLabel="Dropdown"
        cheveronClass="icon-dots-vertical" [options]="options1">
      </maced-dropdown></span>
  </div>
  <maced-table-assessment sortingOrder="desc" tableId="sampleTable" [tableData]="newData" [completeTableData]="data"
    [hasCheckbox]="hasCheckbox" [hasRadio]="hasRadio" checkBoxId='selectAll' [columnAlignment]="columnAlignment"
    [columnHeader]="mappings" (sortEvent)="sortEvent($event)" (change)="onChange()" url="/table" checkBoxLabel="Select All"
    [captionLable]="captionLable" [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'">
  </maced-table-assessment>
  <div class="c-table-pagination" id="table-pagination" *ngIf="screenSize>minimumScreenResolution">
    <maced-pagination paginationId="paginationId" [paginationObject]="paginationObject" [pageSizeList]="pageSizeList">
    </maced-pagination>
  </div>
  <div class="c-table-pagination" id="table-pagination" *ngIf="screenSize<=minimumScreenResolution">
    <maced-pagination paginationId="paginationId" [paginationObject]="paginationObject">
    </maced-pagination>
  </div>
  <maced-button buttonId="buttonId2" size="medieum" type="submit" label="submit" [url]="currentUrl" (click)="onClick()">
  </maced-button>
  <p>{{selectedList | json}} </p>
</div>

<div class="content"  *ngIf="selectedUseCase === 'tableWithOutPaginationHeaderAndNumerics'">
  <h2>Table without Pagination, Header and Numerics</h2>
  <maced-table-assessment sortingOrder="desc" tableId="sampleTable1" [tableData]="dataWithoutNumerics" checkBoxLabel="Select All"
    [completeTableData]="dataWithoutNumerics" [hasCheckbox]="hasCheckbox" [hasRadio]="hasRadio" checkBoxId='selectCheckboxes'
    [columnAlignment]="columnAlignment" [columnHeader]="headers" (sortEvent)="sortEvent($event)" (change)="onChange()"
    url="/table" [captionLable]="captionLable" [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'">
  </maced-table-assessment>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableWithoutRadioAndCheckbox'">
  <h2>Table without Radio and Checkbox</h2>
  <maced-table-assessment sortingOrder="desc" tableId="sampleTable2" [tableData]="tableDataWithText" [showTooltipMsg]="true"
    [completeTableData]="data" [columnAlignment]="columnAlignment" [columnHeader]="textColumnHeaders"
    (sortEvent)="sortEvent($event)" (change)="onChange()" url="/table" [captionLable]="captionLable"
    [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'" checkBoxLabel="Select All">
  </maced-table-assessment>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableBodyWithStaticData'">
<div class="c-input-check-inline">
  <input id="withoutScrollBar" class="c-input-check-inline__input" type="checkbox" name="withoutScrollBar"
      [(ngModel)]="withoutScrollBar">
  <label for="withoutScrollBar" class="c-input-check-inline__label"> Hide Scroll Bar</label>
</div>
</div>
<div class="content" *ngIf="selectedUseCase === 'tableBodyWithStaticData'">
  <h2>Table body with static data</h2>
  <div class="content__wrapper content__wrapper--table-filter">
    <maced-filter-toolbar filterToolbarId="filterToolbarId" [hasSearchOption]="true" [hasSorting]="true"
      [hasFilter]="true">
      <ng-container ngProjectAs="[searchPannel]">
        <form [formGroup]="formElement" (ngSubmit)="onSearchSubmit($event.target[0].value)">
          <maced-search placeholder="Search" globalLang="en" id="input" name="input" [hasIcon]="true" autocomplete="on" type="text"
            value="" errorMessage=" " [label]="searchInputLabelEnglish" formControlName="inputVal" (onClearSearch)="doOnClearSearch()"
            (searchInputValue)="onSearchSubmit($event)" [hasExternalButton]="true" buttonUrl="/table">
          </maced-search>
        </form>
        <span *ngIf="isSearch">Showing {{studentData.length}} of {{completeStudentData.length}} results</span>
      </ng-container>
      <ng-container ngProjectAs="[dropdownPannel]">
        <div class="c-filter-toolbar__sort-filter-group-sortby" *ngIf="!isBrowser">
          <ul class="c-filter-toolbar__sort-filter-group-list">
            <li
              class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown ">
              <maced-dropdown dropdownId="sortBy" name="sortBy" ariaLabel="Dropdown list navigate with tab"
                label="First Name (A-Z)" cheveronClass="icon-chevron-down" [options]="sortByDropdown"  [hasBackgroundActive]="true"
                [selectedOption]="sortByDropdownselectedOptions" outerLabel="Sort By:" dropdownLabelId="dropdownLabelId0">
              </maced-dropdown>
            </li>
            <li 
              class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown">
              <maced-dropdown dropdownId="viewBy" name="viewBy" ariaLabel="Dropdown list navigate with tab" label="First"
                cheveronClass="icon-chevron-down" [options]="viewBydropdown"  [hasBackgroundActive]="true"
                [selectedOption]="viewBydropdownselectedOptions" outerLabel="Attempt:" dropdownLabelId="dropdownLabelId1">
              </maced-dropdown>
            </li>
          </ul>  
        </div>
        <div class="c-filter-toolbar__sort-filter-group__filter">
          <ul class="c-filter-toolbar__sort-filter-group-list">
            <li *ngIf="screenSize > minimumScreenResolution && isBrowser"
              class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown ">
              <maced-dropdown dropdownId="sortBy" name="sortBy" ariaLabel="Dropdown list navigate with tab"
                label="First Name (A-Z)" cheveronClass="icon-chevron-down" [options]="sortByDropdown" [hasBackgroundActive]="true"
                [selectedOption]="sortByDropdownselectedOptions" outerLabel="Sort By:" dropdownLabelId="dropdownLabelId0">
              </maced-dropdown>
            </li>
            <li *ngIf="screenSize > minimumScreenResolution && isBrowser"
              class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown">
              <maced-dropdown dropdownId="viewBy" name="viewBy" ariaLabel="Dropdown list navigate with tab" label="First"
                cheveronClass="icon-chevron-down" [options]="viewBydropdown" [hasBackgroundActive]="true"
                [selectedOption]="viewBydropdownselectedOptions" outerLabel="Attempt:" dropdownLabelId="dropdownLabelId1">
              </maced-dropdown>
            </li>
            <li class="c-filter-toolbar__sort-filter-group-list-item" *ngIf="isBrowser">
              <maced-floating-panel  *ngIf="screenSize > minimumScreenResolution" id="floatingpanel1" [placement]="selectedPlacement" [hasCloseButton]="false"
                [hasBackdrop]="true" [hasCaret]="false" [hasFooter]="true" [buttonList]="buttonList" (applySelectedOptions)="buttonFocus()">
                <ng-container ngProjectAs="[floatingPanelTarget]">
                  <div class="c-filter-button">
                    <maced-button buttonId="buttonId3" size="large" type="button" icon="icon-filter-funnel"
                      [label]="buttonLabelText()" position="left" [ariaLabel]="buttonLabelText()" [ngClass]="{'u-button--badge':( selectedFilterList && selectedFilterList.length>0)}">
                      <ng-container ngProjectAs="[childComponent]">
                        <maced-badge *ngIf="selectedFilterList?.length>0" badgeId="badgeId3" label="badge1"
                          ariaLabel="Ninty" size="dot"></maced-badge>
                      </ng-container>
                    </maced-button>
                  </div>
                </ng-container>
                <ng-container ngProjectAs="[floatingPanelBody]">
                  <div class="c-floating-panel__body c-floating-panel__body--medium">
                    <div class="c-floating-panel__body-block">
                      <ul class="c-floating-panel__body-block-list">
                        <li class="c-floating-panel__body-block-list-item">
                          <maced-dropdown dropdownId="FilterDropdownId" name="FilterDropdownId"
                            ariaLabel="Dropdown list navigate with tab" label="Please select"
                            cheveronClass="icon-chevron-down" [options]="FilterDropdown"
                            [selectedOption]="FilterDropdownselectedOptions" outerLabel="Category"
                            dropdownLabelId="dropdownLabelId10">
                          </maced-dropdown>
                        </li>
                      </ul>
                    </div>
                  </div>
                </ng-container>
              </maced-floating-panel>
  
              <maced-floating-panel *ngIf="screenSize <= minimumScreenResolution" id="floatingpanel2" [placement]="selectedPlacement" [hasCloseButton]="true"
              [hasBackdrop]="true" [hasCaret]="false" [hasFooter]="true" [buttonList]="buttonList" (applySelectedOptions)="buttonFocus()">
              <ng-container ngProjectAs="[floatingPanelTarget]">
                <div class="c-filter-button">
                  <maced-button buttonId="buttonId1" size="large" type="button" icon="icon-filter-funnel"
                    position="left" [label]="buttonLabelText()" [ariaLabel]="buttonLabelText()"  [ngClass]="{'u-button--badge':( selectedFilterList && selectedFilterList.length>0)}">
                    <ng-container ngProjectAs="[childComponent]">
                      <maced-badge *ngIf="selectedFilterList?.length>0" badgeId="badgeId3" label="badge1" ariaLabel="Ninty"
                        size="dot"></maced-badge>
                    </ng-container>
                  </maced-button>
                </div>
              </ng-container>
              <ng-container ngProjectAs="[floatingPanelBody]">
                <div class="c-floating-panel__body c-floating-panel__body--medium">
                  <div class="c-floating-panel__body-header">Filters</div>
                  <div class="c-floating-panel__body-block">
                    <ul class="c-floating-panel__body-block-list">
                      <li class="c-floating-panel__body-block-list-item">
                        <maced-radio-group radioGroupId="radioGroupId1" label="Sort By" [required]="true">
                          <div class="c-input-outer__multiple-item" *ngFor="let item of sortByList let inx = index">
                            <maced-radio [radioId]="item.label + inx" [value]="item.label" [required]="true"
                              [checked]="item.label === item.checked" [name]="item.label" [label]="item.label"
                              (change)="singleCheckbox(item,'sortBy',$event)">
                            </maced-radio>
                          </div>
                        </maced-radio-group>
                      </li>
                      <li class="c-floating-panel__body-block-list-item">
                        <maced-radio-group radioGroupId="radioGroupId2" label="View By" [required]="true">
                          <div class="c-input-outer__multiple-item" *ngFor="let item of viewByList let inx = index">
                            <maced-radio [radioId]="item.label + inx" [value]="item.label" [required]="true"
                              [checked]="item.label === item.checked" [name]="item.label" [label]="item.label"
                              (change)="singleCheckbox(item,'viewBy',$event)">
                            </maced-radio>
                          </div>
                        </maced-radio-group>
                      </li>
                      <li
                        class="c-floating-panel__body-block-list-item c-floating-panel__body-block-list-item--is-active">
                        <maced-dropdown dropdownId="FilterDropdownId" name="FilterDropdownId"
                        ariaLabel="Dropdown list navigate with tab" label="Please select"
                        cheveronClass="icon-chevron-down" [options]="FilterDropdown"
                        [selectedOption]="FilterDropdownselectedOptions" outerLabel="Category"
                        dropdownLabelId="dropdownLabelId10">
                      </maced-dropdown>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>
            </maced-floating-panel>
            </li>
            <li  class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown" *ngIf="!isBrowser">
              <maced-dropdown dropdownId="FilterDropdownId" name="FilterDropdownId"
              ariaLabel="Dropdown list navigate with tab" label="Please select"
              cheveronClass="icon-chevron-down" [options]="FilterDropdown"
              [selectedOption]="FilterDropdownselectedOptions" outerLabel="Category"
              dropdownLabelId="dropdownLabelId10">
            </maced-dropdown>
            </li>
            <li  class="c-filter-toolbar__sort-filter-group-list-item c-filter-toolbar__sort-filter-group-list-item--dropdown" *ngIf="!isBrowser">
              <ng-container *ngFor="let buttonList of buttonList">    
                <maced-button *ngIf="buttonList.hasClearButton" [buttonId]="buttonList.id" color="link" 
                  [type]="isBrowser ? 'button': 'link'" [url]="currentUrl" [label]="buttonList.label"
                  [ariaLabel]="buttonList.label" [queryParams]="buttonList.queryParams"
                  [queryParamsHandling]="buttonList?.url === currentUrl?'merge':''"
                  [routerLink]="buttonList.disabled ? null : buttonList?.url" [disabled]="buttonList.disabled">
                </maced-button>    
                <maced-button *ngIf="buttonList.hasApplyButton" [buttonId]="buttonList.id" color="primary" 
                  [type]="isBrowser ? 'button': 'link'" [url]="currentUrl" [label]="buttonList.label"
                  [ariaLabel]="buttonList.label" [queryParams]="buttonList.queryParams"
                  [queryParamsHandling]="buttonList?.url === currentUrl?'merge':''"
                  [routerLink]="buttonList.disabled ? null : buttonList?.url" [disabled]="buttonList.disabled">
                </maced-button>
              </ng-container>
            </li>
          </ul>
        </div>
      </ng-container>
    </maced-filter-toolbar>
  </div>
  <div class="content__wrapper">
    <maced-table-pt-grading tableId="sampleTable4" [tableData]="studentData" [completeTableData]="studentData" headerCheckboxId = 'headerCheckboxId'
      [columnHeader]="newTextColumnHeaders" [checkboxColumnFixed]="true" [withoutScrollBar]="withoutScrollBar" [hasSubHeader]="true"
      [hasFixedColumns]="true" fixedTableWidth="1500px" fixedRightColumnWidth="90px" [hasCheckBox]="true" [hasAction]="true">
      <ng-container ngProjectAs="[tableProjectedData]">
      </ng-container>
    </maced-table-pt-grading>
    
      <ng-container>
        <div class="content__wrapper-error" *ngIf="studentData.length === 0">
          <maced-error-state [id]="id3" [imageUrl]="imageUrl3" [imageWidthLarge]=202 [imageHeightLarge]=179 [title]="title3" [ariaLabels]="ariaLabels">
            <ng-container ngProjectAs="[content-body]">
              Enter another keyword to search
            </ng-container>
          </maced-error-state>
        </div>
      </ng-container>    
  </div>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableWithoutCheckboxAndFixedColumns'">
  <h2>Table without Checkbox and fixed columns</h2>
  <div class="content__wrapper">
    <maced-table-pt-grading tableId="sampleTable7" [tableData]="withoutSubHeadersStudentData" [completeTableData]="withoutSubHeadersStudentData"
      [columnHeader]="withoutSubHeaders" [hasFixedColumns]="true" [withoutScrollBar]="withoutScrollBar" [hasCheckBox]="false" [hasAction]="false"
      [hasSubHeader]="false" headerCheckboxId = 'headerCheckboxId2'>
    </maced-table-pt-grading>
  </div>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableBodyWithStaticData2'">
  <h2>Table body with static data case 2</h2>
  <div class="content__wrapper table-score--alignment">
    <maced-table-pt-grading tableId="sampleTable7" [tableData]="newTableStudentData" [completeTableData]="newTableStudentData"
      [columnHeader]="newTableHeader"[checkboxColumnFixed]="true" [withoutScrollBar]="withoutScrollBar" [hasSubHeader]="true"
      [hasFixedColumns]="true" fixedTableWidth="1500px" fixedRightColumnWidth="90px" [hasCheckBox]="true" [hasAction]="true"
      headerCheckboxId = 'headerCheckboxId1'>
    </maced-table-pt-grading>
  </div>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableBodyWithStaticDataAndTextArea'">
  <maced-notification-inline notificationInlineId="notificationInlineId" type="error"
    closeButtonArialabel="closeButtonArialabel" [hasCloseButton]="true" ariaLabel="ariaLabel"
    *ngIf="showNotificationInline">
    <ng-container ngProjectAs="[notificationInlineTitle]">
      One or more errors occurred. Please enter valid scores before saving. Examples of errors:
      <ul class="c-notification-inline__content-list">
        <li>The score entered is greater than the maximum score.</li>
        <li>The score entered is NOT a whole number or increment of 0.5.</li>
      </ul>
    </ng-container>
  </maced-notification-inline>
  <h2>Table body with static data and TextArea</h2>
  <div class="content__wrapper">
    <maced-table-pt-grading tableId="sampleTable8" [tableData]="tableStudentDataWithTextArea" [completeTableData]="tableStudentDataWithTextArea"
      [columnHeader]="textAreaTableHeader"[checkboxColumnFixed]="true" [withoutScrollBar]="withoutScrollBar" [hasSubHeader]="false"
      [hasFixedColumns]="true" [hasCheckBox]="true" [hasAction]="false"
      headerCheckboxId = 'headerCheckboxId1' [hasNumericInput]="true">
    </maced-table-pt-grading>
    <div class="c-table--save-button">
      <maced-button buttonId="NotificationInlineButton" type="link" color="primary"
      [queryParams]="{ notificationInlineId: 'notificationInlineId', isOpen: true }" label="Save"
      [url]="currentUrl">
      </maced-button>
    </div>
  </div>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableBodyWithStaticDataAndNumaricInput'">
<maced-notification-inline notificationInlineId="notificationInlineId" type="error"
  closeButtonArialabel="close" [hasCloseButton]="true" ariaLabel="ariaLabel"
  *ngIf="showNotificationInline">
  <ng-container ngProjectAs="[notificationInlineTitle]">
    One or more errors occurred. Please enter valid scores before saving. Examples of errors:
    <ul role="none" class="c-notification-inline__content-list">
      <li role="none">The score entered is greater than the maximum score.</li>
      <li role="none">The score entered is NOT a whole number or increment of 0.5.</li>
    </ul>
  </ng-container>
</maced-notification-inline>
  <h2>Table body with static data and Numeric Input</h2>
  <div class="content__wrapper">
      <div class="c-table-result editable-table-result">
        <span aria-live="polite" aria-atomic="true">
        {{numaricLabel}}
      </span>
        <span class="c-table-result__buttons" *ngIf="screenSize>minimumScreenResolution">
          <maced-button buttonId="buttonId" size="small" type="button" label="Enter 0"
            [disabled]="true" [url]="currentUrl" position="right">
          </maced-button>
          <maced-button buttonId="buttonId1" size="small" type="button" label="Enter the max score"
            [disabled]="true" [url]="currentUrl" position="right">
          </maced-button>
        </span>
        <span *ngIf="screenSize<=minimumScreenResolution" class="c-table-result__buttons c-table-result__buttons--dropdown">
          <maced-dropdown dropdownId="dropdownId2" name="dropdownId2" ariaLabel="Dropdown"
            cheveronClass="icon-dots-vertical" [options]="options2">
          </maced-dropdown></span>
      </div>
      <maced-table-pt-grading tableId="sampleTable8" [tableData]="tableStudentDataWithNumericInput"
        [completeTableData]="tableStudentDataWithNumericInput" [columnHeader]="numericTableHeader" [hasNumericInput]="true"
        [checkboxColumnFixed]="true" [withoutScrollBar]="withoutScrollBar" [hasSubHeader]="false" [hasFixedColumns]="true"
        [hasCheckBox]="true" [hasAction]="false" headerCheckboxId='headerCheckboxId1' (checkboxClickEvent)="checkboxClickEvent($event)">
      </maced-table-pt-grading>
      <div class="c-table--save-button">
        <maced-button buttonId="NotificationInlineButton" type="link" color="primary" (click)="saveData()"
          [queryParams]="{ notificationInlineId: 'notificationInlineId', isOpen: true }" label="Save" [url]="currentUrl">
        </maced-button>
      </div>
  </div>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableWithNestedRows'">
  <h2>Table with nested rows</h2>
  <maced-table-assessment sortingOrder="desc" [hasChildRows]="true" tableId="sampleTable3" [tableData]="rowsData"
    [completeTableData]="rowsData" [columnAlignment]="columnAlignment" [columnHeader]="headerData" [hasTableRowColor] = "true"
    (sortEvent)="sortEvent($event)" (change)="onChange()" url="/table" [captionLable]="captionLable"
    [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'" checkBoxLabel="Select All">
  </maced-table-assessment>

  <div class="c-table-pagination" id="table-pagination" *ngIf="screenSize>minimumScreenResolution">
    <maced-pagination paginationId="paginationId" [paginationObject]="nestedTablepaginationObject" [pageSizeList]="pageSizeList">
    </maced-pagination>
  </div>
  <div class="c-table-pagination" id="table-pagination" *ngIf="screenSize<=minimumScreenResolution">
    <maced-pagination paginationId="paginationId" [paginationObject]="nestedTablepaginationObject">
    </maced-pagination>
  </div>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableNestedRowsWithScroll'">
  <div class="c-input-check-inline">
    <input id="withoutScrollBar1" class="c-input-check-inline__input" type="checkbox" name="tableWithoutScrollBar"
        [(ngModel)]="tableWithoutScrollBar">
    <label for="withoutScrollBar1" class="c-input-check-inline__label"> Hide Scroll Bar</label>
  </div>
  </div>
<div class="content" *ngIf="selectedUseCase === 'tableNestedRowsWithScroll'">
  <h2>Table with nested rows with scroll</h2>
  <maced-table-assessment sortingOrder="desc" [hasChildRows]="true" tableId="sampleTable9" [tableData]="scrollableTableRowaData"
    [completeTableData]="scrollableTableRowaData" [columnAlignment]="columnAlignment" [columnHeader]="scrollableTableHeaderData" [hasTableRowColor] = "true"
    (sortEvent)="sortEvent($event)" (change)="onChange()" url="/table" [captionLable]="captionLable" [hasFixedColumns] = 'true' [hasScrollBar]="true"
    [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'" fixedTableWidth="1500px" checkBoxLabel="Select All" [withoutScrollBar]="tableWithoutScrollBar">
  </maced-table-assessment>

  <div class="c-table-pagination" id="table-pagination" *ngIf="screenSize>minimumScreenResolution">
    <maced-pagination paginationId="paginationId" [paginationObject]="nestedTablepaginationObject" [pageSizeList]="pageSizeList">
    </maced-pagination>
  </div>
  <div class="c-table-pagination" id="table-pagination" *ngIf="screenSize<=minimumScreenResolution">
    <maced-pagination paginationId="paginationId" [paginationObject]="nestedTablepaginationObject">
    </maced-pagination>
  </div>
</div>

<div class="content content--gamification-table"  *ngIf="selectedUseCase === 'tableWithAllModes'">
  <h2>Table with All Modes</h2>
  <maced-table-assessment sortingOrder="desc" tableId="sampleTable15" [tableData]="tableDataWithDifferentModes" checkBoxLabel="Select All"
    [completeTableData]="tableDataWithDifferentModes" [hasCheckbox]="false" [hasRadio]="false" [hideBorder] = 'true'
    [columnAlignment]="columnAlignment" [columnHeader]="textColumnHeaders" (sortEvent)="sortEvent($event)" (change)="onChange()"
    url="/table" [captionLable]="captionLable" [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'"  [hasScrollBar]="true" [withoutScrollBar]="tableWithoutScrollBar" [tabular]="true">
  </maced-table-assessment>
</div>

<div class="content" *ngIf="selectedUseCase === 'tableWithCustomizedRow'">
  <h2>Table with customized row</h2>
  <maced-table-assessment sortingOrder="desc" [hasChildRows]="true" tableId="sampleTable9"
    [tableData]="ScrollableCustomTableRowaData" [completeTableData]="ScrollableCustomTableRowaData"
    [columnAlignment]="columnAlignment" [columnHeader]="ScrollableCustomTableHeaderData" (sortEvent)="sortEvent($event)"
    (change)="onChange()" url="/table" [captionLable]="captionLable" [hasFixedColumns]='true' [hasScrollBar]="true"
    [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'" fixedTableWidth="1500px"
    [withoutScrollBar]="tableWithoutScrollBar">
    <ng-template let-data let-headerData='headerData' #tableRowData>
      <ng-container *ngIf="headerData.field === 'average'">
        <maced-button buttonId="submit1" [ariaLabel]="buttonAriaLabel" [icon]="data[headerData.field]?.icon"
          buttonType="submit"></maced-button>
      </ng-container>
      <ng-container *ngIf="headerData.field === 'assessmentSubmitted'">
        <span>{{data[headerData.field]?.title}}</span>
      </ng-container>

    </ng-template>
  </maced-table-assessment>
</div>

<div class="content" *ngIf="selectedUseCase === 'tablecustom'">
  <h2>Table with customization</h2>
  <div class="content__wrapper table-score--alignment">
    <maced-table-pt-grading tableId="sampleTable7" [tableData]="ptTableCustomStudentData" [completeTableData]="newTableStudentData"
      [columnHeader]="ptTableCustomHeader" [withoutScrollBar]="withoutScrollBar" [hasAction]="true">
      <ng-template let-data let-rowsData='rowsData' #tableRowData>
        <h5>{{data.values.headerText}}</h5>
        <span>{{data.values.text}}</span>
      </ng-template>
    </maced-table-pt-grading>
  </div>
</div>
</ng-container>
<ng-template #noJsContent>
  <div class="content">
    <h2>Table without Pagination, Header and Numerics</h2>
    <maced-table-assessment sortingOrder="desc" tableId="sampleTable1" [tableData]="dataWithoutNumerics" checkBoxLabel="Select All"
      [completeTableData]="data" [hasCheckbox]="hasCheckbox" [hasRadio]="hasRadio" checkBoxId='Select Checkboxes'
      [columnAlignment]="columnAlignment" [columnHeader]="headers" (sortEvent)="sortEvent($event)" (change)="onChange()"
      url="/table" [captionLable]="captionLable" [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'">
    </maced-table-assessment>
  </div>
  <div class="content">
    <h2>Table body with static data case 2</h2>
    <div class="content__wrapper table-score--alignment">
      <maced-table-pt-grading tableId="sampleTable7" [tableData]="newTableStudentData" [completeTableData]="newTableStudentData"
        [columnHeader]="newTableHeader"[checkboxColumnFixed]="true" [withoutScrollBar]="withoutScrollBar" [hasSubHeader]="true"
        [hasFixedColumns]="true" fixedTableWidth="1500px" fixedRightColumnWidth="90px" [hasCheckBox]="true" [hasAction]="true"
        headerCheckboxId = 'headerCheckboxId1'>
      </maced-table-pt-grading>
    </div>
  </div>
  <div class="content">
  <h2>Table with nested rows</h2>
  <maced-table-assessment sortingOrder="desc" [hasChildRows]="true" tableId="sampleTable3" [tableData]="rowsData"
    [completeTableData]="rowsData" [columnAlignment]="columnAlignment" [columnHeader]="headerData"
    (sortEvent)="sortEvent($event)" (change)="onChange()" url="/table" [captionLable]="captionLable"
    [sortingLable]="' sorted in ' +  sortingOrder + ' order by this column'" checkBoxLabel="Select All">
  </maced-table-assessment>
</div>
</ng-template>
